/**
 * FlotaKpiBar — 4 KPIs del módulo Flota con glassmorphism.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import BuildIcon from '@mui/icons-material/Build';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';

const ITEMS = [
  { key: 'vencidos',     label: 'Vencidos',          icon: <WarningAmberIcon />,     gradient: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)', shadow: 'rgba(220, 38, 38, 0.35)' },
  { key: 'proximos_7',   label: 'Próximos 7 días',   icon: <EventAvailableIcon />,   gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', shadow: 'rgba(245, 158, 11, 0.35)' },
  { key: 'en_curso',     label: 'En curso',          icon: <BuildIcon />,            gradient: 'linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)', shadow: 'rgba(14, 165, 233, 0.35)' },
  { key: 'embarcaciones_con_alerta', label: 'Botes con alerta', icon: <DirectionsBoatIcon />, gradient: 'linear-gradient(135deg, #8b5cf6 0%, #6366f1 100%)', shadow: 'rgba(139, 92, 246, 0.35)', isArray: true },
];

export default function FlotaKpiBar({ kpis, loading }) {
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(4, 1fr)' },
      gap: 1.5, mb: 2,
    }}>
      {ITEMS.map(it => {
        const raw = kpis?.[it.key];
        const value = it.isArray ? (Array.isArray(raw) ? raw.length : 0) : (raw ?? 0);
        return (
          <Box key={it.key} sx={{
            position: 'relative', p: 1.5, borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.85)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 4px 16px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.9)',
            border: '1px solid rgba(255, 255, 255, 0.5)',
            overflow: 'hidden',
            transition: 'transform 0.2s ease',
            '&:hover': { transform: 'translateY(-2px)' },
            '&::before': {
              content: '""', position: 'absolute', top: 0, left: 0, right: 0,
              height: 3, background: it.gradient,
            },
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{
                width: 32, height: 32, borderRadius: 2,
                background: it.gradient,
                color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                boxShadow: `0 4px 12px ${it.shadow}`,
                '& svg': { fontSize: 18 },
              }}>{it.icon}</Box>
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Typography sx={{ fontSize: 10, color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  {it.label}
                </Typography>
                <Typography sx={{ fontSize: 17, fontWeight: 800, color: '#0f172a', lineHeight: 1.1 }} noWrap>
                  {loading ? '—' : value}
                </Typography>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}
